const ToastSuccess = ({ size = 20 }) => {
  return (
    <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='17' cy='17' r='17' fill='#21CCA4' fillOpacity='0.1' />
      <path
        d='M23.6663 16.3863V16.9996C23.6655 18.4372 23.2 19.836 22.3392 20.9875C21.4785 22.1389 20.2685 22.9812 18.8899 23.3889C17.5113 23.7965 16.0378 23.7475 14.6893 23.2493C13.3408 22.7511 12.1894 21.8303 11.407 20.6243C10.6245 19.4183 10.2529 17.9916 10.3475 16.5571C10.442 15.1226 10.9978 13.7571 11.9319 12.6643C12.8659 11.5715 14.1282 10.8098 15.5305 10.493C16.9327 10.1762 18.3999 10.3211 19.713 10.9063'
        stroke='#21CCA4'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.6667 11.667L17 18.3403L15 16.3403'
        stroke='#21CCA4'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ToastSuccess
